import PremiumBuyerSubscriptionProvider from './PremiumBuyerSubscription.provider';

export default PremiumBuyerSubscriptionProvider;
